// extracted by mini-css-extract-plugin
module.exports = {"Media__root":"M6EA"};